/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';
/** Services */
import { BydRhsAbstractService } from '../../../../shared/services/byd-rhs-abstract.service';
/** Classes */
import { DsSummaryDashboardData } from '../../../dashboard/classes/ds-summary-dashboard-data.class';
/** Interfaces */
import { DsSummaryDashboardDataInterface } from '../../../dashboard/interfaces/ds-summary-dashboard-data.interface';

@Injectable({
  providedIn: 'root',
})
export class DsFormSummaryDashboardService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Returns the summary form status and their numbers.
   *
   * @param projectId Selected project id
   * @returns Observable<BydModel<DsSummaryDashboardData>>
   */
  public getSummary(projectId: number): Observable<BydModel<DsSummaryDashboardData>> {
    this.path = `/v1/dsform/projects/${projectId}/instances/status/summary`;
    return this.getModels<DsSummaryDashboardData>();
  }

  /**
   * Get datas to inject to chart, datas are the summary on each forms instances grouped by state and map or cateogry.
   *
   * @param projectId Project ID
   * @param param the param
   * @returns Observable<BydModel<DsSummaryDashboardData>>
   */
  public getDashboardFormInstancesSummary(
    projectId: number,
    param: string
  ): Observable<BydModel<DsSummaryDashboardData>> {
    this.path = `/v1/dsform/projects/${projectId}/instances/summary${param ? `?groupBy=${param}` : ''}`;
    return this.getModels<DsSummaryDashboardData>();
  }

  /**
   * Get datas to inject to chart, datas are the summary on each form instances grouped by status and form category.
   *
   * @param projectId Selected project id
   * @param categoryId Selected category id
   * @returns Observable<BydModel<DsSummaryDashboardData>>
   */
  public getFormInstancesSummaryByCategory(
    projectId: number,
    categoryId: number
  ): Observable<BydModel<DsSummaryDashboardData>> {
    this.path = `/v1/dsform/projects/${projectId}/categories/${categoryId}/instances/summary`;
    return this.getModels<DsSummaryDashboardData>();
  }

  /**
   * Create DsSummaryDashboardData instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsSummaryDashboardData` instance.
   */
  public createNewInstance(jsonObject: DsSummaryDashboardDataInterface): DsSummaryDashboardData {
    return new DsSummaryDashboardData(jsonObject);
  }
}
